import { canAccess } from './permissions'
import { useSession } from './session'

/** True when the signed-in user may perform `action` on `resource` (ra-rbac semantics). */
export function useCanAccess(resource: string, action?: string, record?: unknown): boolean {
  const { permissions } = useSession()
  return canAccess({ permissions, resource, action, record })
}
